import Marquee from "react-fast-marquee";

const ITEMS = [
  "Less chaos",
  "More room for what matters",
  "Manage your life",
  "Grow your opportunities",
  "Nine digital resources",
  "Made for real life",
];

export const EditorialMarquee = ({ dark = false }) => (
  <div
    aria-hidden="true"
    className={`overflow-hidden border-y py-5 ${
      dark ? "border-ivory/10 bg-plum" : "border-mauve/30 bg-blushcream"
    }`}
    data-testid="editorial-marquee"
  >
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-6 flex items-center gap-12">
          <span
            className={`font-serif text-2xl italic tracking-tight sm:text-3xl ${
              dark ? "text-ivory/40" : "text-plum/35"
            }`}
          >
            {t}
          </span>
          <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-gold/70" : "bg-rose/60"}`} />
        </span>
      ))}
    </Marquee>
  </div>
);
